<template>
  <div class="waybillTabs">
    <div class="tabs">
      <el-tabs v-model="activeName"
               @tab-click="handleClick"
               class="tabsComtainer">
        <el-tab-pane label="全部运单"
                     name="-1"
                     class="first"></el-tab-pane>
        <el-tab-pane label="待运输"
                     name="0"></el-tab-pane>
        <el-tab-pane label="运输中"
                     name="1"></el-tab-pane>
        <el-tab-pane label="运输完成"
                     name="2"></el-tab-pane>
        <el-tab-pane label="已取消"
                     name="3"></el-tab-pane>
      </el-tabs>
      <div class="tabsSelect">
        <el-input placeholder="请输入运单编号"
                  v-model="searchInput"
                  size="small"
                  class="input-with-select">
          <el-select v-model="waybillSelect"
                     slot="prepend"
                     placeholder="请选择"
                     @change="handleSearchChange">
            <el-option label="普通搜索"
                       value="1"></el-option>
            <el-option label="高级搜索"
                       value="2"></el-option>
          </el-select>
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleorderNumClick"></el-button>
        </el-input>
      </div>
    </div>
    <div class="search"
         v-show="waybillSelect === '2'">
      <el-form class="search-form-inline"
               :model="formInline">
        <!-- <span class="imp">出发地</span> -->

        <el-form-item label="出发地">
          <el-cascader size="small"
                       class="addressStyle"
                       @active-item-change="handleItemChange"
                       :options="options"
                       v-model="formInline.addressFrom"
                       @change="handleChangeFrom">
          </el-cascader>
        </el-form-item>
        <el-form-item label="目的地">

          <el-cascader size="small"
                       class="addressStyle"
                       :options="options"
                       v-model="formInline.addressTo"
                       @active-item-change="handleItemChange"
                       @change="handleChangeTo">
          </el-cascader>

        </el-form-item>
        <el-form-item label="原料">
          <el-input v-model="formInline.material"
                    placeholder="请输入原料名称"></el-input>
        </el-form-item>
        <el-form-item label="货主公司">
          <el-input v-model="formInline.companyName"
                    placeholder="请输入货主公司名称"></el-input>
        </el-form-item>
        <el-form-item label="物流公司">
          <el-input v-model="formInline.userCompanyName"
                    placeholder="请输入物流公司名称"></el-input>
        </el-form-item>
        <el-form-item label="货源编号">
          <el-input v-model="formInline.goodsNum"
                    placeholder="请输入货源编号名称"></el-input>
        </el-form-item>
      </el-form>
      <div class="searchBtn">
        <el-button size="small"
                   @click="handleSearchClick">查询</el-button>
        <el-button size="small"
                   @click="handleCancelSearchClick">
          清除条件
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  heightWaybill,
  provinceList,
  cityList,
  areaList
} from 'apis/index'
import { mapState } from 'vuex'
import Bus from '../../Bus.js'

export default {
  name: 'Tabs',
  data () {
    return {
      options: [],
      // addressFrom: [],
      // addressTo: [],
      // CodeToText,
      // from: '',
      // to: '',
      address: '',
      activeName: '-1',
      searchInput: '',
      waybillSelect: '1',
      formInline: {
        addressFrom: [],
        addressTo: [],
        material: '',
        companyName: '',
        userCompanyName: '',
        goodsNum: '',
        from: '',
        to: ''
      }
    }
  },
  computed: mapState({
    waybillInfo: state => state.heightWaybill.waybillInfo
  }),
  methods: {
    async initData () {
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
      }
    },
    async handleItemChange (val) {
      console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
      // console.log('---', this.options)
    },
    getAddressText (value) {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.formInline.from = this.address
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.formInline.to = this.address
    },

    handleClick () { // 运单状态切换
      let orderState = this.activeName === '-1' ? '' : this.activeName
      Bus.$emit('getOrderState', orderState)
      this.handleCancelSearchClick()
      heightWaybill({
        orderState
      }).then(res => {
        if (res.data.code === 0) {
          let waybillList = res.data.data.result
          this.$store.commit('heightWaybill/changeStatus', orderState)
          this.$store.commit('heightWaybill/updateData', waybillList)
        }
      })
    },
    handleorderNumClick () { // 普通搜索
      let orderState = this.activeName === '-1' ? '' : this.activeName
      heightWaybill({
        orderState: orderState,
        orderNum: this.searchInput
      }).then(res => {
        if (res.data.code === 0) {
          this.searchInput = ''
          const waybillList = res.data.data.result
          this.$store.commit('heightWaybill/changeStatus', this.activeName)
          this.$store.commit('heightWaybill/updateData', waybillList)
        }
      })
    },
    handleSearchClick () { // 高级搜索查询
      let orderState = this.activeName === '-1' ? '' : this.activeName
      heightWaybill({
        orderState: orderState,
        departLand: this.formInline.from,
        destina: this.formInline.to,
        material: this.formInline.material,
        userCompanyName: this.formInline.userCompanyName,
        companyName: this.formInline.companyName,
        goodsNum: this.formInline.goodsNum
      }).then(res => {
        if (res.data.code === 0) {
          Bus.$emit('getSearchInfo', this.formInline)
          this.searchInput = ''
          const waybillList = res.data.data.result
          this.$store.commit('heightWaybill/changeStatus', this.activeName)
          this.$store.commit('heightWaybill/updateData', waybillList)
        }
      })
    },
    handleCancelSearchClick () { // 清除查询条件
      this.searchInput = ''
      this.formInline.from = ''
      this.formInline.to = ''
      this.formInline.material = ''
      this.formInline.userCompanyName = ''
      this.formInline.companyName = ''
      this.formInline.goodsNum = ''
      this.formInline.addressFrom = []
      this.formInline.addressTo = []
    },
    handleSearchChange () {
      console.log(this.waybillSelect)
      Bus.$emit('waybillSelect', this.waybillSelect)
    }

  },
  mounted () {
    this.initData()
  }

}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.waybillTabs
  .tabs
    width 100%
    height 50px
    overflow hidden
    border-bottom 1px solid #ccc
    .tabsComtainer
      width 500px
      float left
      .el-tabs__nav-wrap::after
        height 1px
        bottom 1px solid transparent
      .el-tabs__item
        padding 0
        text-align center
        height 51px
        line-height 50px
        width 92px
        border-bottom 1px solid #ccc
        size12()
        color #5e656f
      .el-tabs__item.is-active
        border-bottom 2px solid #409EFF
        color #1b88ee
      .el-tabs__active-bar
        background transparent !important
      .el-tabs
        float left
    .tabsSelect
      float right
      margin-right 20px
      margin-top 5px
      .el-select .el-input
        width 110px
      .input-with-select .el-input-group__prepend
        background #fff
  .search
    padding 7px 20px
    overflow hidden
    .search-form-inline
      float left
      width calc(100% - 120px)
      margin-top 5px
      .el-form-item
        float left
        margin-bottom 0
        label
          width 97px
        .el-form-item__content
          float left
        .company-name
          width 146px
          padding 0
          margin 0
        .el-input__inner
          width 146px
          height 28px
          size12()
        .search-submit
          padding 5px 20px
          background #fff
          text-align right
          color $bgColor
          size12()
          &:hover
            background $bgColor
            color #fff
    .searchBtn
      width 80px
      float right
      .el-button
        width 78px
        margin 12px 0 0
        padding 7px 15px
</style>
